module.exports = __webpack_public_path__ + "static/bauadvisor.7ba5fc93.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/partners/bauadvisor.png
// module id = 1611
// module chunks = 35783957827783